import { getStore } from "app/store/store"
import { IColorPickerPopupParams } from "ui/model"
import { uiActionCreator } from "ui/store/actions"

export const openColorPickerPopup = (params: IColorPickerPopupParams): void => {
  getStore().dispatch(uiActionCreator.openColorPickerPopup(params))
}

export const closeColorPickerPopup = (): void => {
  if (!getStore().getState().ui.colorPickerPopup.isOpened) {
    return
  }
  getStore().dispatch(uiActionCreator.closeColorPickerPopup())
}
